var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.label
      ? _c(
          "div",
          { staticClass: "text-base font-normal mb-2 flex w-auto items-start" },
          [
            _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
            _vm.isRequired
              ? _c("span", { staticClass: "text-velux-red ml-0.5" }, [
                  _vm._v("*")
                ])
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.hasUploadedFile
      ? _c(
          "div",
          { staticClass: "block mb-4 text-lg bold", on: { click: _vm.remove } },
          [
            _c("i", { staticClass: "far fa-times cursor-pointer mr-2" }),
            _vm._v("\n    " + _vm._s(_vm.$store.state.attachment.name) + "\n  ")
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass:
          "bg-velux-white\n                md:text-xl\n                py-3.5\n                px-7\n                md:py-3\n                font-bold\n                block\n                md:inline-block\n                border-2\n                text-center\n                transition-colors\n                hover:bg-velux-grey-100\n                cursor-pointer",
        attrs: { for: _vm.id }
      },
      [_vm._t("default")],
      2
    ),
    _vm._v(" "),
    _c("input", {
      ref: "file",
      staticClass: "fixed bottom-full",
      attrs: {
        type: "file",
        required: _vm.isRequired,
        name: _vm.name,
        id: _vm.id
      },
      on: {
        change: function($event) {
          return _vm.handleFileUpload($event)
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }